"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoMicroUniverso = exports.dicionarioLogos = void 0;
var react_1 = __importDefault(require("react"));
var large_logo_black_svg_1 = __importDefault(require("../../assets/logos/large-logo-black.svg"));
var large_logo_blue_svg_1 = __importDefault(require("../../assets/logos/large-logo-blue.svg"));
var large_logo_white_svg_1 = __importDefault(require("../../assets/logos/large-logo-white.svg"));
var LogoIconeMU_svg_1 = __importDefault(require("../../assets/logos/LogoIconeMU.svg"));
var LogoMURodape_svg_1 = __importDefault(require("../../assets/logos/LogoMURodape.svg"));
var row_small_logo_black_svg_1 = __importDefault(require("../../assets/logos/row-small-logo-black.svg"));
var row_small_logo_blue_svg_1 = __importDefault(require("../../assets/logos/row-small-logo-blue.svg"));
var row_small_logo_slogan_black_svg_1 = __importDefault(require("../../assets/logos/row-small-logo-slogan-black.svg"));
var row_small_logo_slogan_blue_svg_1 = __importDefault(require("../../assets/logos/row-small-logo-slogan-blue.svg"));
var row_small_logo_slogan_white_svg_1 = __importDefault(require("../../assets/logos/row-small-logo-slogan-white.svg"));
var row_small_logo_white_svg_1 = __importDefault(require("../../assets/logos/row-small-logo-white.svg"));
var stacked_large_logo_black_svg_1 = __importDefault(require("../../assets/logos/stacked-large-logo-black.svg"));
var stacked_large_logo_blue_svg_1 = __importDefault(require("../../assets/logos/stacked-large-logo-blue.svg"));
var stacked_large_logo_slogan_black_svg_1 = __importDefault(require("../../assets/logos/stacked-large-logo-slogan-black.svg"));
var stacked_large_logo_slogan_blue_svg_1 = __importDefault(require("../../assets/logos/stacked-large-logo-slogan-blue.svg"));
var stacked_large_logo_slogan_white_svg_1 = __importDefault(require("../../assets/logos/stacked-large-logo-slogan-white.svg"));
var stacked_large_logo_white_svg_1 = __importDefault(require("../../assets/logos/stacked-large-logo-white.svg"));
var stacked_medium_logo_black_svg_1 = __importDefault(require("../../assets/logos/stacked-medium-logo-black.svg"));
var stacked_medium_logo_blue_svg_1 = __importDefault(require("../../assets/logos/stacked-medium-logo-blue.svg"));
var stacked_medium_logo_slogan_black_svg_1 = __importDefault(require("../../assets/logos/stacked-medium-logo-slogan-black.svg"));
var stacked_medium_logo_slogan_blue_svg_1 = __importDefault(require("../../assets/logos/stacked-medium-logo-slogan-blue.svg"));
var stacked_medium_logo_slogan_white_svg_1 = __importDefault(require("../../assets/logos/stacked-medium-logo-slogan-white.svg"));
var stacked_medium_logo_white_svg_1 = __importDefault(require("../../assets/logos/stacked-medium-logo-white.svg"));
var MULabelBlue_svg_1 = __importDefault(require("../../assets/logos/MULabelBlue.svg"));
var MULabelBlue_Slogan_svg_1 = __importDefault(require("../../assets/logos/MULabelBlue_Slogan.svg"));
var MULabelWhite_svg_1 = __importDefault(require("../../assets/logos/MULabelWhite.svg"));
var MULabelWhite_Slogan_svg_1 = __importDefault(require("../../assets/logos/MULabelWhite_Slogan.svg"));
var MULabelBlack_svg_1 = __importDefault(require("../../assets/logos/MULabelBlack.svg"));
var MULabelBlack_Slogan_svg_1 = __importDefault(require("../../assets/logos/MULabelBlack_Slogan.svg"));
var Mu_Logo_svg_1 = __importDefault(require("../../assets/logos/Mu_Logo.svg"));
var MU_Logo_Icone_Label_svg_1 = __importDefault(require("../../assets/logos/MU_Logo_Icone_Label.svg"));
exports.dicionarioLogos = {
    "LogoIconeMU": LogoIconeMU_svg_1.default,
    "LogoMURodape": LogoMURodape_svg_1.default,
    "largeLogoBlack": large_logo_black_svg_1.default,
    "largeLogoBlue": large_logo_blue_svg_1.default,
    "largeLogoWhite": large_logo_white_svg_1.default,
    "rowSmallLogoBlack": row_small_logo_black_svg_1.default,
    "rowSmallLogoBlue": row_small_logo_blue_svg_1.default,
    "rowSmallLogoSloganBlack": row_small_logo_slogan_black_svg_1.default,
    "rowSmallLogoSloganBlue": row_small_logo_slogan_blue_svg_1.default,
    "rowSmallLogoSloganWhite": row_small_logo_slogan_white_svg_1.default,
    "rowSmallLogoWhite": row_small_logo_white_svg_1.default,
    "stackedLargeLogoBlack": stacked_large_logo_black_svg_1.default,
    "stackedLargeLogoBlue": stacked_large_logo_blue_svg_1.default,
    "stackedLargeLogoSloganBlack": stacked_large_logo_slogan_black_svg_1.default,
    "stackedLargeLogoSloganBlue": stacked_large_logo_slogan_blue_svg_1.default,
    "stackedLargeLogoSloganWhite": stacked_large_logo_slogan_white_svg_1.default,
    "stackedLargeLogoWhite": stacked_large_logo_white_svg_1.default,
    "stackedMediumLogoBlack": stacked_medium_logo_black_svg_1.default,
    "stackedMediumLogoBlue": stacked_medium_logo_blue_svg_1.default,
    "stackedMediumLogoSloganBlack": stacked_medium_logo_slogan_black_svg_1.default,
    "stackedMediumLogoSloganBlue": stacked_medium_logo_slogan_blue_svg_1.default,
    "stackedMediumLogoSloganWhite": stacked_medium_logo_slogan_white_svg_1.default,
    "stackedMediumLogoWhite": stacked_medium_logo_white_svg_1.default,
    "MULabelBlue": MULabelBlue_svg_1.default,
    "MULabelBlue_Slogan": MULabelBlue_Slogan_svg_1.default,
    "MULabelWhite": MULabelWhite_svg_1.default,
    "MULabelWhite_Slogan": MULabelWhite_Slogan_svg_1.default,
    "MULabelBlack": MULabelBlack_svg_1.default,
    "MULabelBlack_Slogan": MULabelBlack_Slogan_svg_1.default,
    "MU_Logo": Mu_Logo_svg_1.default,
    "MU_Icone_Label": MU_Logo_Icone_Label_svg_1.default,
};
var LogoMicroUniverso = function (_a) {
    var _b = _a.tipoLogo, tipoLogo = _b === void 0 ? "largeLogoBlue" : _b, Altura = _a.Altura, Largura = _a.Largura, className = _a.className, style = _a.style;
    var ComponenteLogo = exports.dicionarioLogos[tipoLogo];
    if (!ComponenteLogo) {
        return null;
    }
    return react_1.default.createElement(ComponenteLogo, { height: Altura, width: Largura, className: className, style: style });
};
exports.LogoMicroUniverso = LogoMicroUniverso;
